(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["larachel-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-lr-tab-trigger]');
    if (!trigger) return;
    var section = trigger.closest('[data-lr-tabbed-products]');
    if (!section) return;
    var targetId = trigger.getAttribute('data-lr-tab-target');
    section.querySelectorAll('[data-lr-tab-trigger]').forEach(function (button) {
      var active = button === trigger;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    section.querySelectorAll('[data-lr-tab-panel]').forEach(function (panel) {
      panel.hidden = panel.id !== targetId;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
